import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const HelmetEN = (props) => {

  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);

  return (
    <Helmet htmlAttributes={{lang: props.onTranslate('language')}}>
        <meta
        data-react-helmet="true"
        name="description"
        content={props.onTranslate('meta__description')}
        />
        <meta name="keywords" data-react-helmet="true" content={props.onTranslate('meta__keywords')} />
        <meta name="author" data-react-helmet="true" content="Indigo Nails" />
        <meta charSet="utf-8" />
        <title>{props.onTranslate('title')}</title>
    </Helmet>
  )
}

export default HelmetEN;